export default __webpack_public_path__ + "static/media/close.581106d6.svg";